module.exports = __webpack_public_path__ + "img/5_hillstate.2d105fb1.png";